import { motion } from "framer-motion";
import { Home, Users, HeartHandshake } from "lucide-react";
import { ChapterHeading, EASE } from "./shared";

const SERVICES = [
    {
        icon: Home,
        title: "Atendimento Domiciliar",
        text: "Levo o cuidado especializado até o conforto do lar, em Curitiba e região, respeitando a rotina e a individualidade de cada pessoa idosa.",
    },
    {
        icon: Users,
        title: "Idosos e Famílias",
        text: "Atendo idosos e famílias com acompanhamento cognitivo e emocional, orientando continuamente quem cuida.",
    },
    {
        icon: HeartHandshake,
        title: "Cuidado Humanizado",
        text: "Monto um plano terapêutico individualizado, com escuta ativa, afeto e promoção de autonomia em cada fase do envelhecimento.",
    },
];

const ServicesSection = () => (
    <section id="servicos" className="relative py-20 sm:py-28" data-testid="services-section">
        <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-full bg-gradient-to-b from-white via-lav/30 to-cream" aria-hidden="true" />
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <ChapterHeading number="02" eyebrow="Serviços" align="center" title={<>Como posso <span className="italic text-serenity">cuidar</span> de quem você ama</>} />

            <div className="mt-14 grid gap-7 md:grid-cols-3">
                {SERVICES.map((s, i) => (
                    <motion.div
                        key={s.title}
                        data-testid={`service-card-${i + 1}`}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.8, delay: i * 0.15, ease: EASE }}
                        whileHover={{ y: -8, scale: 1.02 }}
                        className="group relative flex flex-col rounded-[1.75rem] border border-transparent bg-gradient-to-br from-white to-cream p-8 shadow-lg shadow-plum/5 transition-[box-shadow,border-color] duration-300 hover:border-lilac hover:shadow-2xl hover:shadow-lilac/25 sm:p-9"
                    >
                        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-lilac to-serenity text-white shadow-md shadow-serenity/30 transition-transform duration-300 group-hover:scale-110">
                            <s.icon size={24} />
                        </span>
                        <h3 className="mt-6 font-serif text-xl font-semibold text-plum sm:text-2xl">{s.title}</h3>
                        <p className="mt-3 text-base leading-relaxed text-ink">{s.text}</p>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);

export default ServicesSection;
